import React, { Component } from "react";
import { connect } from "react-redux";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import PropTypes from "prop-types";
import { setActiveProject } from "../../actions/ui";
import { selectFilteredProjectsInActiveFeature } from "../../reducers/";
import { projectShape } from "../../modules/project";
import styles from "./listview.module.scss";

class Listview extends Component {
    render() {
        let ids = [];
        const dedupedProjects = this.props.projects.filter((d) => {
            if (d.ID === undefined) {
                return d;
            }
            if (!ids.includes(d.ID)) {
                ids.push(d.ID)
                return d;
            }
            return null;
        })
        const PROJECT_LENGTH = dedupedProjects.length;

        return (
            <div style={{ paddingTop: 50 }}>
                <hr />
                <div className={styles.container}>
                    <p>{PROJECT_LENGTH} projects</p>
                    <BootstrapTable
                        data={dedupedProjects}
                        striped={false}
                        hover={false}
                        pagination={true}
                        options={{
                            sizePerPage: 5,
                            sizePerPageList: [5, 10, 15],
                        }}
                    >
                        <TableHeaderColumn
                            dataField="Project"
                            isKey={true}
                            dataSort={true}
                            width="35%"
                            dataFormat={(cell, row) => (
                                <a
                                    style={{ cursor: "pointer" }}
                                    alt={"View details for: " + cell}
                                    href={""}
                                    onClick={e => {
                                        e.preventDefault();
                                        this.props.setActiveProject(row);
                                    }}
                                >
                                    {cell}
                                </a>
                            )}
                        >
                            Project name
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="LGA" dataSort={true} width="20%">
                            LGA
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="fundName" dataSort={true} width="45%">
                            Fund
                        </TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    projects: selectFilteredProjectsInActiveFeature(state),
});
const mapDispatchToProps = { setActiveProject };

Listview.propTypes = {
    setActiveProject: PropTypes.func.isRequired,
    projects: PropTypes.arrayOf(PropTypes.shape(projectShape)),
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Listview);



// WEBPACK FOOTER //
// ./src/components/listview/listview.js